// extracted by mini-css-extract-plugin
module.exports = {"pageHeading":"provider-create-screen_pageHeading__1KgOC","pageHeadingTitle":"provider-create-screen_pageHeadingTitle__cPJOy"};